import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function atleastOneValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const values = control.value;
        return values.length > 0 ? null : {atleastOne: 'Must provide atleast an email'};
    }
}